import { SplitTreatments } from "@splitsoftware/splitio-react";
import { redirect } from "app/routes/Routes";
import featureFlagsDictionary from "infrastructure/split/feature-flags-dictionary";
import Datetime, { DateFormat } from "v2/domain/common/entities/Datetime";
import { CountryIsoCode } from "v2/domain/common/enums/CountryISOCode";
import BenefitRequestCard from "v2/ui/components/BenefitRequests/components/BenefitRequestCard";
import TitleDescription from "v2/ui/components/BenefitRequests/components/TitleDescription";
import { BenefitTypeEnum } from "v2/domain/common/entities/BenefitType";
import { BenefitStates } from "v2/infrastructure/Benefits/types/BenefitStates";
import Benefit from "v2/domain/benefits/entities/Benefit";

const haveSomeFeatureFlagOff = (names, treatments) =>
  names.some((name) => treatments[name].treatment !== "on");

type SpainBenefitRequestProps = {
  companyId: string;
  benefitsV2: Benefit[];
};

export const SpainBenefitRequest = ({
  companyId,
  benefitsV2,
}: SpainBenefitRequestProps) => {
  const hasItProductEnabled =
    benefitsV2?.find(
      (benefit) => benefit.benefit === BenefitTypeEnum.IT_PRODUCT_BENEFIT
    )?.state === BenefitStates.ACTIVE || false;

  return (
    <>
      <BenefitRequestCard
        label="benefits-section.benefits-request"
        description="benefits-section.review-request-detail"
        onClick={() => {
          const today = Datetime.now().toDatetimeString(DateFormat.ISO_DATE);
          const pastYearDayToday = Datetime.now()
            .subYears(1)
            .toDatetimeString(DateFormat.ISO_DATE);

          redirect(
            `benefits/recurrent-payments/nursery?minRequestedAt=${pastYearDayToday}&maxRequestedAt=${today}&pageSize=10`
          );
        }}
      />
      <SplitTreatments
        names={[featureFlagsDictionary.BT_997]}
        attributes={{ companyId }}
      >
        {({ treatments, isReady }) => {
          if (
            hasItProductEnabled ||
            (isReady &&
              !haveSomeFeatureFlagOff(
                [featureFlagsDictionary.BT_997],
                treatments
              ))
          )
            return (
              <BenefitRequestCard
                label="benefits-section.employees-request"
                description="v2.section-titles.review-the-benefits-requests-made-by-your-employees"
                tag="common-messages.new"
                onClick={() => {
                  window.location.assign(
                    `/v2/employee-requests?companyId=${companyId}`
                  );
                }}
              />
            );
          return <></>;
        }}
      </SplitTreatments>
    </>
  );
};

export const MexicoBenefitRequest = () => {
  return (
    <>
      <TitleDescription
        key={CountryIsoCode.MEXICO}
        title="benefits-section.my-models-title"
        description="benefits-section.my-models-description"
      />
    </>
  );
};

type PortugalBenefitRequestProps = {
  companyId: string;
};

export const PortugalBenefitRequest = ({
  companyId,
}: PortugalBenefitRequestProps) => {
  return (
    <>
      <BenefitRequestCard
        label="benefits-section.benefits-request"
        description="benefits-section.review-request-detail"
        onClick={() => {
          const today = Datetime.now().toDatetimeString(DateFormat.ISO_DATE);
          const pastYearDayToday = Datetime.now()
            .subYears(1)
            .toDatetimeString(DateFormat.ISO_DATE);

          redirect(
            `benefits/recurrent-payments/nursery?minRequestedAt=${pastYearDayToday}&maxRequestedAt=${today}&pageSize=10`
          );
        }}
      />
      <SplitTreatments
        names={[featureFlagsDictionary.BT_997]}
        attributes={{ companyId }}
      >
        {({ treatments, isReady }) => {
          if (
            isReady &&
            !haveSomeFeatureFlagOff([featureFlagsDictionary.BT_997], treatments)
          )
            return (
              <BenefitRequestCard
                label="benefits-section.employees-request"
                description="v2.section-titles.review-the-benefits-requests-made-by-your-employees"
                tag="common-messages.new"
                onClick={() => {
                  window.location.assign(
                    `/v2/employee-requests?companyId=${companyId}`
                  );
                }}
              />
            );
          return <></>;
        }}
      </SplitTreatments>
    </>
  );
};
